import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "play-btn" }
const _hoisted_2 = { class: "time" }

import {onMounted, onBeforeUnmount, ref, computed} from 'vue'
import WaveSurfer from 'wavesurfer.js'
import {Play, Stop} from "utruckin-icons";
import {playOnlyOne, clearActiveWaveSurfer} from '@/utils/audioManager'


export default /*@__PURE__*/_defineComponent({
  __name: 'voiceMessage',
  props: {
    audioUrl: {}
  },
  setup(__props: any) {

const props = __props

const waveRef = ref<HTMLElement | null>(null)
const isPlaying = ref(false)
const currentTime = ref(0)
const duration = ref(0)

let wavesurfer: WaveSurfer | null = null

const togglePlay = async (event: any) => {
  if (!wavesurfer) return
  event.stopPropagation()
  if (wavesurfer.isPlaying()) {
    wavesurfer.pause()
  } else {
    playOnlyOne(wavesurfer)
  }
}

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

const formattedTime = computed(() => {
  return formatTime(isPlaying.value ? currentTime.value : duration.value || 0)
})

onMounted(() => {
  if (!waveRef.value) return

  wavesurfer = WaveSurfer.create({
    container: waveRef.value,
    url: props.audioUrl,
    height: 16,
    barWidth: 3,
    barGap: 2,
    barRadius: 999,
    cursorWidth: 0,
    normalize: true,
    interact: true,
    dragToSeek: true,
    waveColor: '#D0D7E2',
    progressColor: '#2AABEE',
  })

  wavesurfer.on('ready', () => {
    duration.value = wavesurfer?.getDuration() || 0
  })

  wavesurfer.on('play', () => {
    isPlaying.value = true
  })

  wavesurfer.on('pause', () => {
    isPlaying.value = false
  })

  wavesurfer.on('timeupdate', (time) => {
    currentTime.value = time
  })

  wavesurfer.on('finish', () => {
    isPlaying.value = false
    currentTime.value = 0
    if (wavesurfer) clearActiveWaveSurfer(wavesurfer)
  })
})

onBeforeUnmount(() => {
  if (wavesurfer) {
    clearActiveWaveSurfer(wavesurfer)
    wavesurfer.destroy()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "voice-message",
    onClick: _cache[0] || (_cache[0] = (e) => {togglePlay(e)})
  }, [
    _createElementVNode("button", _hoisted_1, [
      (isPlaying.value)
        ? (_openBlock(), _createBlock(_unref(Stop), {
            key: 0,
            size: 16
          }))
        : (_openBlock(), _createBlock(_unref(Play), {
            key: 1,
            size: 16
          }))
    ]),
    _createElementVNode("div", {
      class: "wave-container",
      ref_key: "waveRef",
      ref: waveRef
    }, null, 512),
    _createElementVNode("span", _hoisted_2, _toDisplayString(formattedTime.value), 1)
  ]))
}
}

})